import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { faMailchimp } from '@fortawesome/free-brands-svg-icons';
import { faBuilding, faEnvelope, faUser } from '@fortawesome/free-regular-svg-icons';
import { faCity, faMobile } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { CmsFooterContactsProperties } from '../Models/CmsFooterContactsProperties';
import { CitiesWithManagerCode, Countries } from '../Models/Countries';
import { AgencyService } from '../Services/Agency.service';
import { CMSService } from '../Services/cms.service';
import { RegisterService } from './register.service';
import { RegisterUserProperties } from './RegisterProperties';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
/** Register component*/
export class RegisterComponent {
  /** Register ctor */
  constructor(private agencyService: AgencyService,public cmsService: CMSService,private registerservice: RegisterService, private messageService: MessageService) {

  }
  isPakistan: boolean = false;
  countryList: Countries[] = [];
  CitiesList: CitiesWithManagerCode[] = [];
  companyName = environment.companyName;
  operatingCountry = environment.operatingCountry;
  fauser = faUser;
  famail = faEnvelope;
  faMobile = faMobile;
  faCity = faCity;
  faBuilding = faBuilding;
  footerContacts: CmsFooterContactsProperties[] = [];
  registerobj = new RegisterUserProperties();
  emailSubmitted: Boolean = false;
  loadVar: Boolean = false;
  visitingCardFile: File | null = null;
  visaLicenseFile: File | null = null;
  logoFile: File | null = null;
  visitingCardName : string = '';
  visaLicenseName : string = '';
  logoFileName : string = '';
  ngOnInit() {
    this.getCountries();

   // this.getCities();
    //this.onCountryChange();
    this.cmsService.getFooterData().subscribe((data) => {


      this.footerContacts = data.footerContacts;


    });
  }
  getCountries() {
    try {
      this.agencyService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  onFileChange(event: Event, type: 'visiting' | 'visa' | 'logo'): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    if (file.size > 2 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'File size must be less than 2MB',
        life: 5000
      });
      return;
    }

    switch (type) {
      case 'visiting':
        this.registerobj.visitingCard = file;
        this.visitingCardName = file.name;
        break;

      case 'visa':
        this.registerobj.visitingLicense = file;
        this.visaLicenseName = file.name;
        break;

      case 'logo':
        this.registerobj.companyLogo = file;
        this.logoFileName = file.name;
        break;
    }
  }


  downloadAgreement() {
    const url = 'assets/agreements/company-agreement.pdf'; // or backend URL
    window.open(url, '_blank');
  }

  //getCities() {
  //  try {
  //    this.agencyService.getCities().subscribe((data) => {
  //     // this.countryList = data;
  //      console.log(data);
  //    });
  //  }
  //  catch (e) {
  //    console.log(e);
  //  }
  //}
  //SendMailSubmit(form: NgForm): boolean {
  //  this.emailSubmitted = true;
  //  if (form.invalid) {
  //    return false;
  //  }
  //  else {
  //    if (!this.ValidateEmail(form.value.email)) {
  //      return false;
  //    }
  //    else {
  //      this.registerobj.email = form.value.email;
  //      this.registerobj.fullName = form.value.FullName;
  //      this.registerobj.mobileNo = form.value.mobile;
  //      this.registerobj.city = form.value.city;
  //      this.registerobj.companyName = form.value.companyname;
  //      this.registerobj.district = form.value.district;
  //      this.registerobj.address = form.value.address;
  //      this.loadVar = true;
  //      this.registerservice.CreateRegister(this.registerobj).subscribe({
  //        next: (data) => {
  //          if (data) {

  //            this.messageService.add({ severity: 'success', summary: 'Success Regsitered', detail: 'The Team will contact you shortly!', life: 5000 });
  //            //this.registerobj = new RegisterUserProperties();
  //            form.reset();
  //            this.emailSubmitted = false;
  //          }
  //          else {
  //            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Try Again!', life: 5000 });
  //          }

  //          this.loadVar = false;
  //        }, error: (error: any) => {
  //          console.log(error)
  //          this.loadVar = false;

  //          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Something Went Wrong!`, life: 5000 });
  //        }
  //      });
  //    }
  //  }

  //  return true;
  //}
  //SendMailSubmit(form: NgForm): boolean {
  //  this.emailSubmitted = true;

  //  // 1. Form validation
  //  if (!form || form.invalid) {
  //    return false;
  //  }

  //  // 2. Email validation
  //  if (!this.ValidateEmail(form.value.email)) {
  //    return false;
  //  }

  //  // 3. Mandatory file validations
  //  if (!this.registerobj.visitingCard) {
  //    this.messageService.add({
  //      severity: 'error',
  //      summary: 'Missing Document',
  //      detail: 'Visiting Card is required',
  //      life: 4000
  //    });
  //    return false;
  //  }

  //  // 4. Map form values to model
  //  this.registerobj.email = form.value.email;
  //  this.registerobj.fullName = form.value.FullName;
  //  this.registerobj.mobileNo = form.value.mobile;
  //  this.registerobj.city = form.value.city;
  //  this.registerobj.country = this.registerobj.country; // already bound via dropdown
  //  this.registerobj.companyName = form.value.companyname;
  //  this.registerobj.district = form.value.district;
  //  this.registerobj.address = form.value.address;

  //  this.registerobj.numberOfTickets = form.value.tickets
  //    ? Number(form.value.tickets)
  //    : null;

  //  this.registerobj.suggestedAmount = form.value.suggestedAmount
  //    ? Number(form.value.suggestedAmount)
  //    : null;

  //  this.registerobj.bankAccountNumber1 = form.value.bankAccount1 || null;
  //  this.registerobj.bankAccountNumber2 = form.value.bankAccount2 || null;

  //  // 5. Submit request
  //  this.loadVar = true;

  //  this.registerservice.CreateRegister(this.registerobj).subscribe({
  //    next: (data) => {
  //      if (data) {
  //        this.messageService.add({
  //          severity: 'success',
  //          summary: 'Successfully Registered',
  //          detail: 'Our team will contact you shortly.',
  //          life: 5000
  //        });

  //        form.resetForm();
  //        this.emailSubmitted = false;
  //      } else {
  //        this.messageService.add({
  //          severity: 'error',
  //          summary: 'Error',
  //          detail: 'Please try again.',
  //          life: 5000
  //        });
  //      }

  //      this.loadVar = false;
  //    },
  //    error: (error: any) => {
  //      console.error(error);
  //      this.loadVar = false;

  //      this.messageService.add({
  //        severity: 'error',
  //        summary: 'Error',
  //        detail: 'Something went wrong. Please try later.',
  //        life: 5000
  //      });
  //    }
  //  });

  //  return true;
  //}
  SendMailSubmit(form: NgForm): boolean {
    this.emailSubmitted = true;

    // 1. Form validation
    if (!form || form.invalid) {
      return false;
    }

    // 2. Email validation
    if (!this.ValidateEmail(form.value.email)) {
      return false;
    }

    // 3. Mandatory file validations
    if (this.operatingCountry === 'Pakistan') {
      if (!this.registerobj.visitingCard) {
        this.messageService.add({
          severity: 'error',
          summary: 'Missing Document',
          detail: 'Visiting Card is required',
          life: 4000
        });
        return false;
      }
    }
    // 4. Map form values to model (except files)
    this.registerobj.email = form.value.email;
    this.registerobj.fullName = form.value.FullName;
    this.registerobj.mobileNo = form.value.mobile;
    this.registerobj.city = form.value.city;
    this.registerobj.country = this.registerobj.country; // bound via dropdown
    this.registerobj.companyName = form.value.companyname;
    if (this.operatingCountry === 'Pakistan') {
      this.registerobj.district = form.value.district;
      this.registerobj.address = form.value.address;
      this.registerobj.numberOfTickets = form.value.numberOfTickets ? Number(form.value.numberOfTickets) : null;
      this.registerobj.suggestedAmount = form.value.suggestedAmount ? Number(form.value.suggestedAmount) : null;
      this.registerobj.bankAccountNumber1 = form.value.bankAccountNumber1 || null;
      this.registerobj.bankAccountNumber2 = form.value.bankAccountNumber2 || null;
    }

    // 5. Create FormData for API
    const formData: FormData = new FormData();
    for (const key in this.registerobj) {
      if (this.registerobj.hasOwnProperty(key)) {
        const value = (this.registerobj as any)[key];
        if (value !== null && value !== undefined) {
          // Append files separately
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else {
            formData.append(key, value.toString());
          }
        }
      }
    }

    // 6. Submit request
    this.loadVar = true;

    this.registerservice.CreateRegister(formData).subscribe({
      next: (data) => {
        if (data) {
          this.messageService.add({
            severity: 'success',
            summary: 'Successfully Registered',
            detail: 'Our team will contact you shortly.',
            life: 5000
          });
          form.resetForm();
          this.emailSubmitted = false;
          // reset files
          this.registerobj.visitingCard = null;
          this.registerobj.visitingLicense = null;
          this.registerobj.companyLogo = null;
          this.logoFileName = '';
          this.visaLicenseName = '';
          this.visitingCardName = '';
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Please try again.',
            life: 5000
          });
        }
        this.loadVar = false;
      },
      error: (error: any) => {
        console.error(error);
        this.loadVar = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Something went wrong. Please try later.',
          life: 5000
        });
      }
    });

    return true;
  }

  downloadAgreements() {
    this.registerservice.downloadCompanyDetails()
      .subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = `agreements.zip`;
          a.click();

          window.URL.revokeObjectURL(url);
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: '', detail: 'Failed to downlaod agreements' });
        }
      });
  }
  public ValidateEmail = (email: string): boolean => {
    const regularExpression =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  
  onCountryChange(event: any) {

    //this.getCities();
    const selected = event.value;

    this.isPakistan = selected === 'Pakistan';
    if (!this.isPakistan) {
      this.CitiesList = [];
      this.registerobj.city = ""; // clear previous value
    }
    else {
      try {
        this.agencyService.getCities().subscribe((data) => {
          this.CitiesList = data;
          console.log(data);
        });
      }
      catch (e) {
        console.log(e);
      }
    }
  }


}
